import React, { useState, useEffect, useMemo } from "react";
import {  Button, Tooltip, TableProps } from "antd";
import { useSelector } from "react-redux";
import Loader from "../../../Components/Loader/Loader";
import calculatePagination from "../../../Components/CustomPagination/Pagination/Pagination";
import SetStatus from "../../../Components/SetStatus/SetStatus";
import {
  GetInvoicesService,
  UpdateInvoiceStage,
} from "../../../Services/InvoiceService/InvoiceService";
import "./Exported.css";
import AlertMessage from "../../../Components/AlertMessage/AlertMessage";
import CommonTable from "../../../Components/CustomTable/CustomTable";
import Pagination from "../../../Components/CustomPagination/Pagination/Pagination";
import SelectedClientCard from "../../../Components/SelectedClientCard/SelectedClientCard";

// Type definitions
interface RowData {
  id: number;
  status: string;
  user: string;
  date: string;
  supplier: string;
  category: string;
  advanced: string;
  documentOwner: string;
  total: string;
  selected: boolean;
}

const Exported = () => {
   var INVOICE_PER_FETCH = 5;
  const selectedClient = useSelector((state: any) => state.selectedClient);
  const [dataSource, setDataSource] = useState<RowData[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [selectAll, setSelectAll] = useState(false);
  const [cursor, setCursor] = useState<string>("");
    const [totalInvoiceCount, setTotalInvoiceCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
   const [invoices, setInvoices] = useState<any[]>([]);
     const [hasMore, setHasMore] = useState(true);
      const [isLoadingMore, setIsLoadingMore] = useState(false);
     
  //const [pageSize, setPageSize] = useState(10);

  // Derived values
  // const indexOfLastRecord = currentPage * pageSize;
  // const indexOfFirstRecord = indexOfLastRecord - pageSize;
  // const currentRecords = useMemo(
  //   () => dataSource.slice(indexOfFirstRecord, indexOfLastRecord),
  //   [dataSource, indexOfFirstRecord, indexOfLastRecord]
  // );
  
const onRowCheckboxChange = (row: RowData, checked: boolean) => {
  setSelectedRows((prev) => {
    if (checked) {
     
      return [...prev, row.id].filter(
        (value, index, self) => self.indexOf(value) === index
      );
    } else {
      return prev.filter((selectedId) => selectedId !== row.id);
    }
  });
};



  // console.log("Selected Rows:", dataSource);
const handleSelectAll = () => {
  if (selectAll) {
    setSelectedRows([]);
  } else {
    setSelectedRows(invoices.map(inv => inv.id)); //  IDs only
  }
  setSelectAll(!selectAll);
};



useEffect(() => {
  if (invoices.length === 0) {
    setSelectAll(false);
    return;
  }

  setSelectAll(selectedRows.length === invoices.length);
}, [selectedRows, invoices]);


  const columns = useMemo(
    () => [
    {
  key: "selected",
  title: (
    <input
      type="checkbox"
      checked={selectAll}
      onChange={handleSelectAll}
    />
  ),
  dataIndex: "",
  isCheckbox: true,
  showSortArrows: false,
},


      {
        title: "ID",
        dataIndex: "id",
        key: "id",
        sorter: (a: RowData, b: RowData) => a.id - b.id,
      },
      {
        title: "Status",
        dataIndex: "stageId",
        key: "stageId",
         isStatus: true,
         
        // sorter: (a: RowData, b: RowData) => a.id - b.id,
        // render: (stageId: number) => SetStatus(stageId),
      },
      {
        title: "User",
        dataIndex: "documentOwner",
        key: "documentOwner",
        sorter: (a: RowData, b: RowData) => {
          const valueA = a.documentOwner || ""; // Empty strings are sorted last
          const valueB = b.documentOwner || "";
          return valueA.localeCompare(valueB);
        },
      },
      {
        title: "Description",
        dataIndex: "description",
        key: "description",
        sorter: (a: RowData, b: RowData) => a.id - b.id,
        render: (text: string) => (
          <Tooltip title={text}>
            <span>
              {text.length > 15 ? `${text.substring(0, 15)}...` : text}
            </span>
          </Tooltip>
        ),
      },
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
         isDate: true,
        sorter: (a: RowData, b: RowData) =>
          new Date(a.date).getTime() - new Date(b.date).getTime(),
        render: (text: string) => {
          const date = new Date(text); // Parse the ISO date
          const formattedDate = date.toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          }); // Formats as dd/mm/yyyy
          return (
            <Tooltip title={formattedDate}>
              <span>{formattedDate}</span>
            </Tooltip>
          );
        },
      },
      {
        title: "Supplier",
        dataIndex: "supplier",
        key: "supplier",
        sorter: (a: RowData, b: RowData) =>
          a.supplier.toLowerCase().localeCompare(b.supplier.toLowerCase()),
      },
      {
        title: "Category",
        dataIndex: "category",
        key: "category",
        sorter: (a: RowData, b: RowData) =>
          a.category.localeCompare(b.category),
      },
      // {
      //   title: "Advanced",
      //   dataIndex: "advanced",
      //   key: "advanced",
      //   sorter: (a: RowData, b: RowData) =>
      //     parseFloat(a.advanced) - parseFloat(b.advanced),
      // },
      {
        title: "Total",
        dataIndex: "total",
        key: "total",
        sorter: (a: RowData, b: RowData) =>
          parseFloat(a.total) - parseFloat(b.total),
        render: (discountValue: number) => (
          <Tooltip title={discountValue}>
            <span>
              {discountValue != null ? discountValue.toFixed(2) : "0.00"}
            </span>
          </Tooltip>
        ),
      },
    ],
    [selectAll, selectedRows]
  );

  // Fetch data from the server
  const FetchData = async (loadMore = false) => {
    try {
      setLoading(true);
      const result = await GetInvoicesService(
        3,
      selectedClient.selectedClient.userId,
      INVOICE_PER_FETCH,
        loadMore ? cursor : "" 
      );

  if (result?.Items && result.TotalItem) {
      setTotalInvoiceCount(result.TotalItem);
      
      setInvoices((prev) =>
        loadMore ? [...prev, ...result.Items] : result.Items
      );
      setCursor(result.NextCursor || "");
      setHasMore(result.HasMore);
    }
    } catch (error) {
      console.error("Error fetching invoice data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchData();
  }, []);

   const loadMoreInvoicesOnScroll = async () => {
    // alert("check");
    if (hasMore) {
        setIsLoadingMore(true);       // start loading
      await FetchData(true);    // fetch next batch
     setIsLoadingMore(false);  
      
    }
    // Use this else part to send alert on reaching the end of list
    //else alert("nothing to fetch ");
  };


  const HandleClick = async () => {
    if (selectedRows.length === 0) {
      // message.error("Please select at least one row to archive.");
      AlertMessage({
        text: "Please select at least one row to archive.",
        type: "error",
      });
      return;
    }

    setLoading(true);
    try {
      await Promise.all(
        selectedRows.map((rowID) => UpdateInvoiceStage(4, rowID))
      );
      //message.success("Invoice archived successfully");
      AlertMessage({
        text: "Invoice archived successfully",
        type: "success",
      });
      await FetchData();
    } catch (error) {
      console.error("Error archiving invoices:", error);
      //message.error("Failed to archive invoices. Please try again.");
      AlertMessage({
        text: "Failed to archive invoices. Please try again.",
        type: "error",
      });
    } finally {
      setLoading(false);
      setSelectAll(false);
      setSelectedRows([]);
    }
  };

  if (!selectedClient.selectedClient?.userId) {
    return (
      <h1>Please select a client to view their invoices in exported stage.</h1>
    );
  }

  if (loading) {
    return <Loader />;
  }
  if (invoices.length === 0) {
    return (
      <div>
        <h1>No invoices found for this client</h1>
      </div>
    );
  }

  return (
    <>
      <div className="selected-client-toolbar">
        <SelectedClientCard />
        <Button
          type="primary"
          onClick={HandleClick}
           style={{
            backgroundColor: selectedRows.length === 0 ? "#787878ff" : "var(--color-brand)", // disabled color
            color: "white",
            border: "none",
          }}
          disabled={selectedRows.length === 0}>
          Archive
        </Button>
      </div>
      <div className="custom-table-wrapper">
        <CommonTable
          infinityScroll={true}
          loadMoreInvoicesOnScroll={loadMoreInvoicesOnScroll}
          columns={columns}
          data={invoices}
          selectedRowKeys={selectedRows}
          onRowCheckboxChange={onRowCheckboxChange}
          selectAll={selectAll}
          handleSelectAll={handleSelectAll}
            stageId={3}            // pass current stageId
           userId={selectedClient.selectedClient?.userId}
        />
   
     
      </div>
       {/* <Pagination
       storageKey="part1_currentPage"
        currentPages={currentPage}
        totalItems={dataSource.length}
        itemsPerPage={pageSize}
        onPageChange={(page) => setCurrentPage(page)}
      /> */}
       <h2 style={{ textAlign: "center",color: "var(--color-brand)" }}>
       { invoices.length} / {totalInvoiceCount}{" "}
  
      </h2>
    </>
  );
};

export default Exported;
